import type { FaireProductEntity } from "../../entity_types/product";

export const p_97pspet94z: FaireProductEntity = {
  token: "p_97pspet94z",
  type: "product",
  name: "Curious Elixir No. 5 Booze-Free Cocktails",
  brandToken: "b_3opsa00um8",
  brandName: "Curious Elixirs",
  imageUrl:
    "https://cdn.faire.com/fastly/5d40a80c097a8a20f618bfc4d79e8cf519399c4b6a18a56f0a35a0c4f4045f16.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ebe97825ce4a100e750766cfcc7a0daec2bb125232daa6b325b5899af924c71.jpeg",
    "https://cdn.faire.com/fastly/415d7af184170220feeb63c58749cbd795de0eac818884c89232827e6776a3a9.jpeg",
    "https://cdn.faire.com/fastly/e16ddb088972a82bfb9f43867bcc501ec4435b5299d5b65c5aa110a3ccd63d97.jpeg",
    "https://cdn.faire.com/fastly/5f47976951f0bad853cd8008139a09d8b440f21b70a28fc2f324503c5bb0eafe.png",
  ],
  priceDollars: 101.85,
  description:
    'Our smoked cherry chocolate old fashioned.\n\nRich dark cherry gives way to smokey American oak and dark chocolate, while a gentle burn lingers like our favorite stirred whiskey drinks. With no refined sugar and zero alcohol, Curious Elixir No. 5 is a bold booze-free craft cocktail that leaves you yearning for another sip in front of the fire, and wondering, "Why didn\'t I order more of these?" Enjoy stirred on the rocks, garnished with orange peel, cherry, or rosemary.',
  tags: [],
  msrpDollars: 203.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:49.206Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
